import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import { TopBar } from "@/components/Brand";
import { PageLoader, Empty } from "@/components/kit";
import { api, errMsg } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { SiteFooter } from "@/pages/Landing";

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    setPage(null);
    api.get(`/public/pages/${slug}`).then((r) => setPage(r.data)).catch((e) => setError(errMsg(e)));
  }, [slug]);
  useSeo({ title: page ? page.seo_title || page.title : undefined, description: page?.meta_description });

  return (
    <div className="min-h-screen bg-[#0B0F17]">
      <TopBar />
      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-8">
        {error ? <Empty title="Page not found" text={error}><Link to="/" className="text-[#CCFF00]">Go home</Link></Empty> : !page ? <PageLoader /> : (
          <article data-testid="cms-page">
            <h1 className="font-display text-4xl font-black uppercase tracking-tight text-white sm:text-5xl" data-testid="cms-page-title">{page.title}</h1>
            <div className="cms-body mt-8 text-base leading-relaxed text-slate-300" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.body.includes("<") ? page.body : page.body.split(/\n{2,}/).map((p) => `<p>${p.replace(/\n/g, "<br/>")}</p>`).join("")) }} />
          </article>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
